export default __webpack_public_path__ + "static/media/past-blue.92672fd4.svg";